import { DateSelectInput } from "../DateSelectInput";
import { InputGroup, BaseDateSelectInputGroupProps } from "../InputGroup";

export type DateSelectInputGroupProps = Omit<BaseDateSelectInputGroupProps, "input">;

export const DateSelectInputGroup = (props: DateSelectInputGroupProps) => {
  return <InputGroup {...props} input={DateSelectInput} />;
};
